import React, { forwardRef } from 'react';
import PropTypes from 'prop-types';
import FormLabel from '../FormLabel';
import FormError from '../FormError';
import { StyledTextAreaContainer, StyledTextAreaWrapper, StyledTextArea, StyledTextAreaBottom, StyledCounter } from './styled';

const TextArea = forwardRef(({ id, placeholder, label, name, value, error, fullWidth, maxLength, disabled, errorText, color, readonly, rows, resize, charCounter, customStyle, onChange, height, onKeyDown }, ref) => {
  return (
    <StyledTextAreaContainer
      disabled={disabled}
      readonly={readonly}
      error={error}
      fullWidth={fullWidth}
      customStyle={customStyle}
    >
      {label && <FormLabel htmlFor={id}>{label}</FormLabel>}
      <StyledTextAreaWrapper>
        <StyledTextArea
          ref={ref}
          id={id}
          placeholder={placeholder}
          name={name}
          onChange={onChange}
          value={value}
          maxLength={maxLength}
          color={color}
          readOnly={readonly}
          rows={rows}
          resize={resize}
          height={height}
          onKeyDown={onKeyDown}
        />
      </StyledTextAreaWrapper>
      <StyledTextAreaBottom>
        {error && errorText && <FormError>{errorText}</FormError>}
        {charCounter && maxLength && <StyledCounter>{`${value.length}/${maxLength}`}</StyledCounter>}
      </StyledTextAreaBottom>
    </StyledTextAreaContainer>
  )
});

TextArea.propTypes = {
  id: PropTypes.string,
  placeholder: PropTypes.string,
  label: PropTypes.string,
  name: PropTypes.string,
  value: PropTypes.string,
  error: PropTypes.bool,
  fullWidth: PropTypes.bool,
  maxLength: PropTypes.number,
  disabled: PropTypes.bool,
  errorText: PropTypes.string,
  color: PropTypes.string,
  readonly: PropTypes.bool,
  rows: PropTypes.number,
  resize: PropTypes.oneOf(['none', 'vertical', 'horizontal', 'both']),
  counter: PropTypes.bool,
  customStyle: PropTypes.array,
  onChange: PropTypes.func,
  height: PropTypes.number,
  onKeyDown: PropTypes.func
};

TextArea.defaultProps = {
  error: false,
  fullWidth: false,
  disabled: false,
  readonly: false,
  rows: 4,
  resize: 'none',
  counter: false,
  onChange: undefined
};

export default React.memo(TextArea);